import { QuestionConfig, Team } from '../types/GameplayTypes';
import type { GameplayQuestion, GameplayState } from './GameplayStore';

export function isBestAnswer(_question: QuestionConfig, answerId: number): boolean {
	return answerId === 0;
}

export function opponentOf(team: Team): Team {
	return (team === Team.A) ? Team.B : Team.A;
}

export function roundPoints(state: Readonly<GameplayState>): number {
	const question = state.questions[state.round];
	return question?.answers
		.filter(answer => answer.revealed)
		.reduce((acc, answer) => acc + answer.points, 0)
		?? 0;
}

export function revealRemaining(question: GameplayQuestion) {
	question.answers.forEach(answer => {
		if (!answer.revealed) {
			answer.revealed = true;
		}
	});
}

export function allAnswersRevealed(question: GameplayQuestion): boolean {
	return question.answers.every(answer => answer.revealed);
}
